import React from "react";
import { titleCase } from "../../../lib/general-helper";
import classNames from "classnames";

const PvPStatSection = ({ pvpData }) => {
  const allianceStat = pvpData?.stats?.factions?.filter((obj) => obj.faction === "alliance")[0]?.popularity ?? 0;
  const hordeStat = pvpData?.stats?.factions?.filter((obj) => obj.faction === "horde")[0]?.popularity ?? 0;
  const topThreeRaces = pvpData?.stats?.races?.sort((a, b) => b.popularity - a.popularity).slice(0, 3);

  return (
    <div className="pvp-stat-section-container">
      <div className="left-sections">
        <div className="image-section">
          <div className="label">Top Races:</div>
          <div className="images-container">
            {topThreeRaces?.map((race, index) => (
              <div key={index}>
                <img className="race-img" src={`https://static.bigbrain.gg/wow/races/${race.race}.webp`} alt={race.race} />
                <div className="name-and-value-container top-races">
                  <div className="img-name">{titleCase(race.race)}</div>
                  <div className={classNames("img-value", { "top-value": index === 0 })}>{race.popularity + "%"}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="stat-border" />
      <div className="right-sections">
        <div className="image-section">
          <div className="label">Faction Popularity:</div>
          <div className="images-container">
            <div>
              <img src="https://static.bigbrain.gg/wow/assets/alliance_icon.png" alt="Alliance" />
              <div className="name-and-value-container">
                <div className="img-name">Alliance</div>
                <div className={classNames("img-value", { "top-value": allianceStat >= hordeStat })}>{allianceStat + "%"}</div>
              </div>
            </div>
            <div>
              <img src="https://static.bigbrain.gg/wow/assets/horde_icon.png" alt="Horde" />
              <div className="name-and-value-container">
                <div className="name-and-value-container">
                  <div className="img-name">Horde</div>
                  <div className={classNames("img-value", { "top-value": hordeStat >= allianceStat })}>{hordeStat + "%"}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PvPStatSection;
